// removed by extract-text-webpack-plugin
module.exports = {"message_popup_form":"_1S_GFo-G","message_success":"_14UQJcMs","message_container":"_3vDTjnbx","message_delete":"_2J1zd2rm","buttons_box":"_1JW8gdx1"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/Messages/InfoWarning/InfoWarning.styl
// module id = 398
// module chunks = 0